import { SortOrder } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { ALL_ITEMS } from '@/consts/interface';
import { PREFETCH_ROW_COUNT } from '@/consts/pagination';
import { toObject } from '@/utils/object';
import { camelToSnakeCase } from '@/utils/queries';
import { itemsPerPageAtom, pageAtom } from './pagination';
import {
  clientOrderByMetricKeyAtom,
  clientOrderDirectionAtom,
  serverOrderByMetricKeyAtom,
  serverOrderDirectionAtom,
} from './table';

export const serverOrderParamsAtom = atom(get => {
  const orderBy = get(serverOrderByMetricKeyAtom);
  const orderDirection = get(serverOrderDirectionAtom).toUpperCase();

  return {
    order_by: toObject(orderBy && camelToSnakeCase(orderBy), `${orderDirection} NULLS LAST`) as Record<
      string,
      SortOrder
    >,
  };
});

export const pageAndOrderParamsAtom = atom(get => {
  const itemsPerPage = get(itemsPerPageAtom);
  const page = get(pageAtom);

  return {
    limit: itemsPerPage,
    offset: itemsPerPage === ALL_ITEMS ? 0 : (page - 1) * itemsPerPage,
    order_by: get(serverOrderParamsAtom).order_by,
  };
});

export const clientOrderParamsAtom = atom(get => {
  const orderBy = get(clientOrderByMetricKeyAtom);
  const orderDirection = get(clientOrderDirectionAtom).toUpperCase();

  return {
    order_by: toObject(orderBy && camelToSnakeCase(orderBy), `${orderDirection} NULLS LAST`) as Record<
      string,
      SortOrder
    >,
  };
});

export const adjustedOffsetAtom = atom(get => {
  const { offset } = get(pageAndOrderParamsAtom);
  return Math.floor(offset / PREFETCH_ROW_COUNT) * PREFETCH_ROW_COUNT;
});
